import { render, staticRenderFns } from "./CardWithTitle.vue?vue&type=template&id=1dcb894e&"
import script from "./CardWithTitle.vue?vue&type=script&lang=ts&"
export * from "./CardWithTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CardWithTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
